<template>
  <div :class="['address-info-item', { 'address-info-item--bg-disabled': isInConfirm }]">
    <h4 class="address-info-item__full-name">{{ fullName }}</h4>
    <p class="address-info-item__info text-address">
      <span class="address-info-item__postal-code">{{ postalCode }}</span>
      <span class="address-info-item__address">
        <div class="address-info-item__address--pc">
          <span> {{ address }} </span>
          <text-ellipsis v-if="buildingName">
            {{ buildingName }}
          </text-ellipsis>
        </div>

        <span class="address-info-item__address--sp">
          <span> {{ address }} </span>
          <text-ellipsis v-if="buildingName">
            {{ buildingName }}
          </text-ellipsis>
        </span>
      </span>
    </p>
    <div class="address-info-item__action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
import TextEllipsis from '@/components/TextEllipsis.vue'

export default {
  components: {
    TextEllipsis,
  },
  props: {
    fullName: {
      type: String,
      default: () => '',
    },
    postalCode: {
      type: String,
      default: () => '',
    },
    address: {
      type: String,
      default: () => '',
    },
    buildingName: {
      type: String,
      default: () => '',
    },
    isInConfirm: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    changeAddress() {
      this.$emit('change-address')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/address-info-item.scss';
</style>
